import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export const dashboardLogoutApi = createApi({
  reducerPath: "dashboardLogoutApi", 
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL }),
  tagTypes: ["DashboardSession"],
  endpoints: (build) => ({
     updateDashboardSessionEnd: build.mutation<void, { userId: string; dashboardSession: DashboardSession }>({
          query: ({ userId, dashboardSession }) => ({
            url: `/dashboard/user/${userId}/session-end`,
            method: "PATCH",
            body: dashboardSession,
          }),   
          invalidatesTags: ["DashboardSession"], 
        })
  }),

});


export const {
    useUpdateDashboardSessionEndMutation
} = dashboardLogoutApi;

export interface DashboardSession {
    dashboardSessionId: string;
    dashboardSessionStartTimestamp: string | null;
    dashboardSessionEndTimestamp: string | null;
  }